import './App.css';

function Oct31() {
    return (
        <>
        <div className='blog-post'>
            <div className='datestyle h3 '>Oct31st</div>
                <p>So, the point of this post is to test the overflow CSS property in the blog components here...</p>
                <p>.... cause I think it's broken</p>
                <br></br>
                <p></p>
                <p>It's Halloween BTW!! Happy Halloween!!</p>     
        </div>
        </>
    );
}

export default Oct31;